import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { BodyWrapper, Header, MainWrapper, Message } from '@components';
import { businessQuery } from '@queries';

import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';
import { BulkUpdateWebsite } from './BulkUpdateWebsite/BulkUpdateWebsite.jsx';

// add new bulk actions here as they're built
const BULK_EDIT_ACTIONS = [
  { value: 'bulk_update_website', label: 'Bulk Update Website' },
];

export const BulkEdit = () => {
  const { businessID } = useParams();
  const [action, setAction] = useState(BULK_EDIT_ACTIONS[0].value);

  const { data: businessData } = useQuery(businessQuery(businessID));

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <span>Bulk Edit</span>
            </li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>Bulk Edit</h1>
            </div>

            <div className="sb-form-item-formgroup sb-form-item-select">
              <label htmlFor="bulk-edit-action">Action</label>
              <div className="sb-form-item-content">
                <select
                  id="bulk-edit-action"
                  value={action}
                  onChange={(e) => setAction(e.target.value)}
                >
                  {BULK_EDIT_ACTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {action === 'bulk_update_website' && (
              <BulkUpdateWebsite businessID={businessID} />
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
